import { assetUrl } from '../utils/assetUrl'
interface AvatarProps {
  firstName?: string
  lastName?: string
  avatar?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export default function Avatar({ firstName = '', lastName = '', avatar, size = 40, className = '', style }: AvatarProps) {
  const initials = `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase() || '👤'

  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-tint)',
        color: 'var(--forest-green)',
        fontSize: size * 0.4,
        fontWeight: 700,
        flexShrink: 0,
        ...style,
      }}
    >
      {avatar ? (
        <img
          src={assetUrl(avatar)}
          alt="Avatar"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        initials
      )}
    </div>
  )
}
